import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  SimpleSearch,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { ChangeEvent, useState } from 'react';
import { messages } from '../../../core-utils/messages/homepagemessages';
import componentConstants from '../../../core-utils/messages/componentConstants';
import {
  formatGroupsTableData,
  getEmployerTableData,
  getInProgressGroups,
  individualGroupsTableColumns,
} from '../../../core-utils/helper-utils/homePageHelper';
import ProgressBar from '../../../../public/Images/progressive bar.png';
import { IEmployerGroupResponseData } from '../../../pages/HomePage';
import { useStores } from '../../../stores';

export interface ClaimsAIQTabProps {
  employerGroupList: IEmployerGroupResponseData[];
  setEmployerGroupList: React.Dispatch<
    React.SetStateAction<IEmployerGroupResponseData[]>
  >;
  handleEmployerGroupCardClick: any;
  defaultRoute: string;
}

const ClaimsAIQTab: React.FC<ClaimsAIQTabProps> = ({
  employerGroupList,
  setEmployerGroupList,
  handleEmployerGroupCardClick,
  defaultRoute,
}) => {
  const { classes } = makeStyles()({
    tableHeader: {
      marginTop: '28px',
      '& .MuiTableHead-root': {
        backgroundColor: '#F2F4FA',
      },
    },
    progressContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: '0.5rem',
      filter: 'blur(0px)',
      position: 'absolute',
      textAlign: 'center',
      color: '#596180',
      backgroundColor: '#FAFAFC',
      padding: '4px 8px',
      borderRadius: '4px',
      zIndex: 1,
      whiteSpace: 'nowrap',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
    },
  })();

  const pageConstants = componentConstants.PAGES.HOME_PAGE;
  const pageSize = 5;

  const employerGroupStore = useStores().employerGroupStore;

  const [searchValue, setSearchValue] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any>([]);
  const [
    columnIdForSubCategories,
    setColumnIdForSubCategories,
  ] = useState<string>('');
  const [pageCount, setPageCount] = useState<number>(
    Math.ceil(
      employerGroupStore.allEmployerGroupsData?.filter(
        (item) => item.is_claims_present === true,
      ).length / pageSize,
    ),
  );
  const [page, setPage] = useState<number>(1);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    if (!value || value.length <= 2) {
      setPageCount(
        Math.ceil(
          employerGroupStore.allEmployerGroupsData?.filter(
            (item) => item.is_claims_present === true,
          ).length / pageSize,
        ),
      );
      setFilteredData([]);
      return;
    }
    const filteredData = employerGroupList?.filter((group: any) => {
      return group?.employer_group_name
        ?.toLowerCase()
        .includes(value.toLowerCase());
    });

    setPageCount(Math.ceil((filteredData?.length || 0) / pageSize));

    setPage(1);
    setFilteredData(filteredData);
  };

  const handleHeaderMouseEnter = (column: any, setColumnId?: any) => {
    setColumnId(column?.id || column?.sortColumnName);
  };

  const handleHeaderMouseLeave = (setColumnId?: any) => {
    setColumnId('');
  };
  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPage(page);
  };
  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    const newList = employerGroupList
      ? [...employerGroupList].sort((a: any, b: any) => {
          if (a[sortColumnName] < b[sortColumnName]) {
            return -1 * sortOrder;
          } else if (a[sortColumnName] > b[sortColumnName]) {
            return 1 * sortOrder;
          }
          return 0;
        })
      : [];

    setEmployerGroupList(newList);
  };
  const getDataForTable = () => {
    return filteredData.length > 0 ? filteredData : employerGroupList;
  };

  return (
    <>
      <Grid className={classes.tableHeader}>
        <TextField
          placeholder={pageConstants.SEARCH}
          height="44px"
          startAdornment={
            <SimpleSearch
              height="24px"
              width="24px"
              stroke={patientAccessTheme.palette.text.lowemphasis}
            />
          }
          value={searchValue}
          onChange={(event: any) => handleSearch(event.target.value)}
          showStartAdornment={true}
          style={{ marginBottom: '24px', width: '100%' }}
        />
        <BasicTable
          isFullTable
          width="100%"
          columns={individualGroupsTableColumns}
          rowsData={formatGroupsTableData(
            getEmployerTableData(getDataForTable(), page, pageSize),
            handleEmployerGroupCardClick,
            defaultRoute,
          )}
          columnId={columnIdForSubCategories}
          handleHeaderMouseEnter={(column: any) =>
            handleHeaderMouseEnter(column, setColumnIdForSubCategories)
          }
          handleHeaderMouseLeave={() =>
            handleHeaderMouseLeave(setColumnIdForSubCategories)
          }
          showOnHoverHeader={true}
          showPagination={true}
          pageCount={pageCount}
          handlePagination={handlePageChange}
          pageNumber={page}
          handleMenuItem={handleSort}
          showInProgress={true}
          progressBarIndex={3}
          blurTextStyle={{
            filter: 'blur(3px)',
          }}
          rowsWithProgress={getInProgressGroups(
            employerGroupList!,
            page,
            pageSize,
          )}
          overlayContent={
            <Grid className={classes.progressContainer}>
              <Typography fontSize="12px" lineHeight="22px" fontType="semiBold">
                {messages.IN_PROGRESS}
              </Typography>
              <img src={ProgressBar} />
            </Grid>
          }
          displayType="row"
          handleOnClick={() => {}}
        />
      </Grid>
    </>
  );
};

export default ClaimsAIQTab;
